<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <AppHeader />
    <main class="container mx-auto px-4 py-8">
      <ExchangeDashboard />
    </main>
  </div>
</template>

<script setup lang="ts">
import AppHeader from './components/AppHeader.vue'
import ExchangeDashboard from './views/ExchangeDashboard.vue'
</script>
